export default __webpack_public_path__ + "image/header-status-0@3x-12299daa.jpg";